import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { ProductPartWrapper } from '@yme/components/ProductDetailsPage/components/ProductPartWrapper';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { RegularTextLevel5 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ProductPartWrapperStyled = styled(ProductPartWrapper) `
  width: 100%;
  padding: 12px;
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
`;
export const RegularTextLevel5Styled = styled(RegularTextLevel5) `
  span {
    ${getTextStyles('Ubuntu', 400, 12, 16)}
    color: ${colorCoreBlack300};
  }
`;
export const ProductPartName = styled(Link) `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  text-decoration: none;
  color: ${colorCoreBlack900Base};
`;
